import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges,
} from "@angular/core";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  PlanningProjectsSelectListComponent
} from "../planning-projects-select-list/planning-projects-select-list.component";
import * as moment from "moment";
import {PlanningHttpService} from "../../services/planning-http.service";

require('./planning-projects-select.scss');
@Component({
  standalone: false,
  selector: 'app-planning-projects-select',
  templateUrl: './planning-projects-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningProjectsSelectComponent implements OnInit, OnChanges {

  @Input() selectedProject: any;
  @Input() isDisabled: boolean;
  @Input() dateRange: { from: number, to: number };
  @Output() onSelectProject = new EventEmitter<string>();

  public selectedProjectName: string = '';
  public projects: any[];

  constructor(@Inject(PanelService) private panelService: PanelService, @Inject(PlanningHttpService) private planningHttpService: PlanningHttpService) {
  }

  ngOnInit() {
    this.setSelectedProjectName();
    this.getProjects();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedProject && !changes.selectedProject.isFirstChange()) {
      this.setSelectedProjectName();
    }
  }

  onShowPanel(event) {
    if (!!this.isDisabled) {
      return;
    }

    const panel = this.panelService.open(PlanningProjectsSelectListComponent, event, {
      selectedProjectId: this.selectedProject?.id,
      projects: this.projects.sort((a, b) => b.createdAt - a.createdAt)
      // dateRange: {
      //   from: moment(this.selectedProject.from).startOf('day').valueOf(),
      //   to: moment(this.selectedProject.to).endOf('day').valueOf()
      // }
    }, {
      width: 200,
      height: 300
    })

    if (panel) {
      panel.afterClose$.subscribe((data) => {
        if (data?.selectedProject) {
          this.onSelectProject.emit(data.selectedProject);
        }
      })
    }
  }

  private setSelectedProjectName() {
    this.selectedProjectName = !!this.selectedProject ? this.selectedProject.name : '';
  }

  getProjects(cursor?: string) {
    const params: { cursor?: string, from: number, to: number, limit: number } = {
      from: moment(this.selectedProject.from).startOf('day').valueOf() || moment().startOf('day').valueOf(),
      to: moment(this.selectedProject.to).endOf('day').valueOf() || moment().endOf('day').valueOf(),
      limit: 200
    };
    // if (cursor) {
    //   params.cursor
    // }
    // this.isFetchingData = true;
    this.planningHttpService.getProjects(params).subscribe(
      {
        next: (res) => {
          // this.cursor = res.cursor;
          this.projects = res.list || [];
          // this.projects = _.uniqBy([...this.projects, ...res.list], 'id');
          // this.cdr.detectChanges();
          // this.isFetchingData = false;
        },
        // error: (error) => {
        //   this.isFetchingData = false;
        // },
        // complete: () => {
        //   this.isFetchingData = false;
        // }
      }
    )
  }

}
